;(function () {
  if (window.PillovelyPopularProductsSliderInitialized) return
  window.PillovelyPopularProductsSliderInitialized = true

  const selector = '[data-popular-products-slider]'

  function initPopularProductsSlider(root) {
    if (!root || root.dataset.sliderInitialized === 'true') return

    const viewport = root.querySelector('[data-popular-products-viewport]')
    const prevButton = root.querySelector('[data-popular-products-prev]')
    const nextButton = root.querySelector('[data-popular-products-next]')
    const desktopMedia = window.matchMedia('(min-width: 576px)')

    if (!viewport) return

    root.dataset.sliderInitialized = 'true'

    let activeIndex = 0
    let ticking = false

    function getItems() {
      return Array.from(root.querySelectorAll('[data-popular-products-item]'))
    }

    function getMaxScrollLeft() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth)
    }

    function syncViewportWidth() {
      root.style.setProperty('--popular-products-viewport-width', `${viewport.clientWidth}px`)
    }

    function getClosestIndex() {
      const items = getItems()
      if (!items.length) return 0

      return getClosestIndexForScrollLeft(viewport.scrollLeft, items)
    }

    function getClosestIndexForScrollLeft(scrollLeft, items) {
      const sliderItems = items || getItems()
      if (!sliderItems.length) return 0

      let closestIndex = 0
      let smallestDistance = Number.POSITIVE_INFINITY

      sliderItems.forEach(function (item, index) {
        const distance = Math.abs(item.offsetLeft - scrollLeft)
        if (distance < smallestDistance) {
          smallestDistance = distance
          closestIndex = index
        }
      })

      return closestIndex
    }

    function getMaxActiveIndex() {
      const items = getItems()
      if (!items.length) return 0

      return getClosestIndexForScrollLeft(getMaxScrollLeft(), items)
    }

    function updateButtons() {
      if (!prevButton || !nextButton) return

      const maxScrollLeft = getMaxScrollLeft()
      const maxActiveIndex = getMaxActiveIndex()
      const atStart = viewport.scrollLeft <= 2
      const atEnd = viewport.scrollLeft >= maxScrollLeft - 2
      const noOverflow = maxScrollLeft <= 2

      prevButton.disabled =
        !desktopMedia.matches || noOverflow || atStart || activeIndex === 0
      nextButton.disabled =
        !desktopMedia.matches || noOverflow || atEnd || activeIndex >= maxActiveIndex
    }

    function syncState() {
      syncViewportWidth()
      activeIndex = getClosestIndex()
      updateButtons()
    }

    function requestSync() {
      if (ticking) return

      ticking = true
      window.requestAnimationFrame(function () {
        syncState()
        ticking = false
      })
    }

    function handleResize() {
      syncViewportWidth()
      requestSync()
    }

    function scrollToIndex(index) {
      const items = getItems()
      if (!items.length) return

      const targetIndex = Math.max(0, Math.min(index, getMaxActiveIndex()))
      const targetLeft = Math.min(items[targetIndex].offsetLeft, getMaxScrollLeft())

      viewport.scrollTo({
        left: targetLeft,
        behavior: 'smooth',
      })
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollToIndex(activeIndex - 1)
      })
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollToIndex(activeIndex + 1)
      })
    }

    viewport.addEventListener('scroll', requestSync, { passive: true })

    if (typeof desktopMedia.addEventListener === 'function') {
      desktopMedia.addEventListener('change', syncState)
    } else if (typeof desktopMedia.addListener === 'function') {
      desktopMedia.addListener(syncState)
    }

    window.addEventListener('resize', handleResize)

    syncState()
  }

  function initAllPopularProductsSliders(container) {
    const scope = container && container.querySelectorAll ? container : document
    scope.querySelectorAll(selector).forEach(initPopularProductsSlider)
  }

  window.initPopularProductsSliders = initAllPopularProductsSliders

  initAllPopularProductsSliders()
  document.addEventListener('shopify:section:load', function (event) {
    initAllPopularProductsSliders(event.target)
  })
})()
